import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  template: `
    <div style="padding-top:15px;text-align:center">
        <h4 style="border-bottom:1px solid grey;padding:5px 0px">OOP's Something Went Wrong.</h4>
        <p >We are unable to process your request at the moment.Sorry for the inconvenence.please try again later</p>
    </div>
    `
})
export class GlobalErrorComponent {
  constructor(@Inject(MAT_DIALOG_DATA) private error:any){
    
  }
}